<template>
  <el-autocomplete
    :value="value"
    :fetch-suggestions="symbolsList"
    :disabled="disabled"
    clearable
    @input="emitInput"
    @change="emitChange"
    @select="emitSelect"
  />
</template>
<script>
  import { symbolsApi } from '@/api';

  export default {
    name: 'AutocompleteSymbol',
    props: {
      value: { type: String },
      disabled: { type: Boolean, default: false },
    },
    data() {
      return {};
    },
    methods: {
      async symbolsList(value, cb) {
        const response = await symbolsApi.autocompleteFetch(value);
        const symbols = response.data.map((item) => ({
          label: item.name,
          value: item.name,
        }));
        cb(symbols);
      },
      emitInput(newValue) {
        this.$emit('input', newValue);
      },
      emitChange(newValue) {
        this.$emit('change', newValue);
      },
      emitSelect({ value }) {
        this.emitInput(value);
        this.emitChange(value);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .el-autocomplete {
    width: 100%;
  }
</style>
